// extracted by mini-css-extract-plugin
export var content = "default_page-module--content--j4PZR";
export var container = "default_page-module--container--uppS-";
export var body = "default_page-module--body--R0HN9";
export var header = "default_page-module--header--Nt+jB";
export var footer = "default_page-module--footer--Bl3KB";
export var progress = "default_page-module--progress--i0nKS";
export var floatLeft = "default_page-module--floatLeft--Zsp0Z";
export var floatRight = "default_page-module--floatRight--77-Za";